import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';

import * as Highcharts from 'highcharts';
import { NO_VALUE } from '../../shared/pipes/dash/dash.pipe';

@Component({
  selector: 'app-circle-progress-bar',
  templateUrl: './circle-progress-bar.component.html',
  styleUrls: ['./circle-progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CircleProgressBarComponent implements OnInit, OnChanges {
  highCharts: typeof Highcharts = Highcharts;
  chart: Highcharts.Chart;

  @Input() size = 125;
  @Input() percent;
  @Input() descriptionKey: string;
  @Input() color = '#FFC938';
  @Input() roundPercent = false;

  chartOptions: Highcharts.Options = (<unknown>{
    chart: {
      type: 'solidgauge',
      width: '160',
      height: '160',
    },
    colors: ['#FFC938'],
    title: null,

    tooltip: {
      enabled: false,
    },

    pane: {
      center: ['50%', '50%'],
      size: '125px',
      startAngle: 0,
      endAngle: 360,
      background: {
        backgroundColor: '#EEE',
        innerRadius: '75%',
        outerRadius: '100%',
        borderWidth: 0,
      },
    },

    yAxis: {
      min: 0,
      max: 100,
      labels: {
        enabled: false,
      },

      lineWidth: 0,
      minorTickInterval: null,
      tickPixelInterval: 400,
      tickWidth: 0,
    },

    plotOptions: {
      solidgauge: {
        innerRadius: '75%',
      },
    },
    credits: {
      enabled: false,
    },
  }) as Highcharts.Options;

  get value(): string {
    return isNaN(this.percent)
      ? NO_VALUE
      : this.roundPercent
      ? Math.round(this.percent) + '%'
      : this.percent + '%';
  }

  setChartInstance(chart: Highcharts.Chart): void {
    this.chart = chart;
  }

  ngOnInit(): void {
    this.constructSeries();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.percent.previousValue !== changes.percent.currentValue &&
      this.chartOptions.series
    ) {
      (this.chartOptions.series[0] as any).data = [this.percent];
      this.chart.update(this.chartOptions, true);
    }
  }

  private constructSeries(): void {
    this.chartOptions.chart.width = `${this.size + 40}`;
    this.chartOptions.chart.height = `${this.size + 40}`;
    (this.chartOptions.pane as Highcharts.PaneOptions).size = `${this.size}px`;
    this.chartOptions.colors = [this.color];
    this.chartOptions.series = [
      {
        name: 'name',
        data: [this.percent],
        dataLabels: {
          enabled: false,
        },
      },
    ] as any;
  }
}
